var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"app-header","order":2}},[_c('div',{class:`app-header-wrapper ${_vm.vFooterClass}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }